var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('next-double-icon',{attrs:{"outer-icon":['fal', 'map-marker'],"inner-icon":_vm.innerIcon}})}
var staticRenderFns = []

export { render, staticRenderFns }